module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-input"
  }, [_c('input', {
    ref: _vm.filePickerId,
    staticClass: "form-control-file file-picker",
    attrs: {
      "type": "file",
      "aria-describedby": "fileHelp",
      "accept": "image/*"
    },
    on: {
      "change": _vm.imageChanged
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "select-button",
    attrs: {
      "type": "button",
      "value": "画像を選択…"
    },
    on: {
      "click": _vm.openFilePicker
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileName),
      expression: "fileName"
    }]
  }, [_vm._v(_vm._s(_vm.fileName))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    staticClass: "cancel-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("取り消し")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1279916!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/ImageInput.vue
// module id = 356
// module chunks = 1